import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import noProductImage from '../../../assets/images/noProductImg_420x420.jpg'




class ProductItem extends Component {

    constructor(props) {
        super(props)

        this.state = {
            open: false,
            stock: 'InStock',
            quantity: 1,
            image: ''
        }
    }

    variantStyle = (color) => {
        if (color && color === '#FFF' || color === '#FFFFFF' || color === 'White' || color === 'WHITE' || color === 'white')
            return ({ backgroundColor: color, border: '1px solid #777' })
        else
            return ({ backgroundColor: color })
    }

    onClickHandle(img) {
        this.setState({ image: img });
    }
    onOpenModal = () => {
        this.setState({ open: true });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    minusQty = () => {
        if (this.state.quantity > 1) {
            this.setState({ stock: 'InStock' })
            this.setState({ quantity: this.state.quantity - 1 })
        }
    }

    plusQty = () => {
        if (this.props.product.stock >= this.state.quantity) {
            this.setState({ quantity: this.state.quantity + 1 })
        } else {
            this.setState({ stock: 'Out of Stock !' })
        }
    }
    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }

    render() {
        const { product, symbol, onAddToCartClicked, onAddToWishlistClicked, themeLayoutId ,presentURL } = this.props;
        // onAddToCompareClicked
        // let RatingStars = []
        // for(var i = 0; i < product.rating; i++) {
        //     RatingStars.push(<i className="fa fa-star" key={i}></i>)
        // } 
        // 
        return (
            <React.Fragment>

           {/* Pet Theme Start */}

                {themeLayoutId === "L04" &&
                <div>
                    <div className="product-box m-0">
                        <div className="img-wrapper">
                            <div className="lable-block"></div>
                                <div className="front">
                                    <a href="/multikart/left-sidebar/product/102">
                                        <img src="https://react.pixelstrap.com/assets/images/pets/pro/8.jpg" className="img-fluid lazyload bg-img" alt="" />
                                    </a>
                                </div>
                            <div className="cart-info cart-wrap">
                                <button title="Add to cart">
                                    <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                                </button>
                                
                                <a href="javascript:void(0)" data-toggle="modal" data-target="#quick-view" title="Quick View">
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                </a>
                                <a title="Compare" href="/multikart/compare">
                                    <i className="fa fa-refresh" aria-hidden="true"></i>
                                </a>
                            </div>
                        </div>
                        <div className="product-detail "><div>
                            <div className="rating"></div>
                            <a href="/multikart/left-sidebar/product/102">
                                <h6>Turkey and Chicken</h6>
                            </a>
                            <h4>$75
                                <del>
                                <span className="money">$150</span>
                                </del>
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
            }

            {/* // end pet  */}

            {/* Kids Theme */}

            {themeLayoutId === 'L05' &&

                <div className="product-box product-wrap">
                    <div className="img-wrapper">
                        <div className="lable-block">
                            <span className="lable3">new</span>
                        </div>
                        <div className="front">
                            <a href="/multikart/left-sidebar/product/120">
                                <img src="https://react.pixelstrap.com/multikart/assets/images/kids/product/1.jpg" className="img-fluid" alt="" />
                            </a>
                        </div>
                        <div className="back">
                            <a href="/multikart/left-sidebar/product/120">
                                <img src="https://react.pixelstrap.com/multikart/assets/images/kids/product/1.jpg" className="img-fluid" alt="" />
                            </a>
                        </div>
                        <div className="cart-box">
                            <button title="Add to cart">
                                <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                            </button>
                           
                            <a href="javascript:void(0)" data-toggle="modal" data-target="#quick-view" title="Quick View">
                                <i className="fa fa-search" aria-hidden="true"></i>
                            </a>
                            <a title="Compare" href="/multikart/compare">
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                    <div className="product-detail  text-center"><div>
                        <div className="rating">
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                            <i className="fa fa-star"></i>
                        </div>
                        <a href="/multikart/left-sidebar/product/120">
                            <h6>Turkey</h6>
                        </a>
                        <h4>$150</h4>
                    </div>
                </div>
            </div>

            }

            {/* end Kids Theme */}


            {/* Beaty Theme Start */}

            {(themeLayoutId === "L01" || themeLayoutId === "L02" || themeLayoutId === "L03" ) &&
            
            <div className="product-box" style={{paddingBottom:'60px'}} >
                <div className="img-wrapper">
                    <div className="lable-block">
                        {(product.ACP_SKU_OVERLAY_TEXT == 'New') ? <span className="lable3">new</span> : ''}
                        {(product.ACP_SKU_OVERLAY_TEXT == 'On Sale') ? <span className="lable4">on sale</span> : ''}
                    </div>
                    <div className="front">
                        <Link to={`/PD/${product.LOT_CD}`}>
                        {product.SKU_IMAGE && product.SKU_IMAGE.length > 45 && product.SKU_IMAGE !== '\/images\/noProductImg_45x45.jpg' ? 
                            
                            <img
                            src={`${
                                product.variants ?
                                    this.state.image ? this.state.image : product.SKU_IMAGE
                                    : product.SKU_IMAGE
                                }`}
                            className="img-fluid"
                            alt="" />:<img
                            src={noProductImage}
                            className="img-fluid"
                            alt="" /> }</Link>
                    </div>
                    <div className="cart-info cart-wrap">
                        {/* <button title="Add to cart" onClick={onAddToCartClicked}>
                            <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                        </button> */}
                       
                        {/* <a href="javascript:void(0)" data-toggle="modal"
                            data-target="#quick-view"
                            title="Quick View"
                            onClick={this.onOpenModal}
                        ><i className="fa fa-expand" aria-hidden="true"></i></a> */}
                        {/* <Link to={`${process.env.PUBLIC_URL}/compare`} title="Compare" onClick={onAddToCompareClicked}>
                            <i className="fa fa-refresh" aria-hidden="true"></i></Link> */}
                    </div>
                    {/* {product.variants ?
                        <ul className="product-thumb-list">
                            {product.variants[0].PDM_VARIANT_DETAIL.map((variant_color, i) =>
                                <li className={`grid_thumb_img ${(variant_color.SKU_IMAGE === this.state.image) ? 'active' : ''}`} key={i}>
                                    <a href="javascript:void(0)" title="Add to Wishlist">
                                        <img src={`${variant_color.SKU_IMAGE}`} onClick={() => this.onClickHandle(variant_color.SKU_IMAGE)} />
                                    </a>
                                </li>)}
                        </ul> : ''} */}

                </div>
                <div className="product-detail" style={{textAlignLast:'center'}}>
                    <div>
                        {/* <div className="rating">
                                {RatingStars}
                            </div> */}
                        <Link to={`/PD/${product.LOT_CD}`}>
                            <h6>{product.ACP_INFOCUS_TITLE_DESC}</h6>
                        </Link>
                        <h6>{symbol} {parseInt(product.LOT_PRICE)}
                            {/* <del><span className="money">&nbsp;{parseInt(product.LOT_PRICE)}</span></del> */}
                        </h6>
                        {/* {product.variants ?
                            <ul className="color-variant">
                                {product.variants[0].PDM_VARIANT_DETAIL.map((variant_color, i) => {
                                    return (
                                        <li style={variant_color.SKU_VARIANT_HEXCODE ? this.variantStyle(variant_color.SKU_VARIANT_HEXCODE) : this.variantStyle('#000')}
                                            key={i}
                                            title={variant_color.SKU_VARIANT_VALUE_DESC}
                                            onClick={() => this.onClickHandle(variant_color.SKU_IMAGE)}
                                        ></li>)
                                })}
                            </ul> : ''} */}
                    </div>
                </div>
                <Modal open={this.state.open} onClose={this.onCloseModal} center>
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content quick-view-modal">
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-6  col-xs-12">
                                        <div className="quick-view-img">
                                            <img
                                                src={`${
                                                    product.variants ?
                                                        this.state.image ? this.state.image : product.SKU_IMAGE
                                                        : product.SKU_IMAGE
                                                    }`}
                                                alt="" className="img-fluid" />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 rtl-text">
                                        <div className="product-right">
                                            <h2> {product.ACP_INFOCUS_TITLE_DESC} </h2>
                                            <h3>{symbol}{Math.round(Number.parseFloat(product.LOT_PRICE))}</h3>
                                            {product.variants ?
                                                <ul className="color-variant">
                                                    {product.variants[0].PDM_VARIANT_DETAIL.map((variant_color, i) => {
                                                        return (
                                                            <li style={{ backgroundColor: variant_color.SKU_VARIANT_HEXCODE ? variant_color.SKU_VARIANT_HEXCODE : '#777' }}
                                                                key={i}
                                                                title={variant_color.SKU_VARIANT_VALUE_DESC}
                                                                onClick={() => this.onClickHandle(variant_color.SKU_IMAGE)}
                                                            ></li>)
                                                    })}
                                                </ul> : ''}
                                            <div className="border-product">
                                                <h6 className="product-title">product details</h6>
                                                <p>{product.ACP_INFOCUS_TITLE_DESC}</p>
                                            </div>
                                            <div className="product-description border-product">
                                                {product.variants ?
                                                    <div className="size-box">
                                                        <ul>
                                                            {product.variants[1].PDM_VARIANT_DETAIL.map((size, i) => {
                                                                return <li key={i}><a href="#">{size.SKU_VARIANT_VALUE_DESC}</a></li>
                                                            })}
                                                        </ul>
                                                    </div> : ''}
                                                <h6 className="product-title">quantity</h6>
                                                <div className="qty-box">
                                                    <div className="input-group">
                                                        <span className="input-group-prepend">
                                                            <button type="button" className="btn quantity-left-minus" onClick={this.minusQty} data-type="minus" data-field="">
                                                                <i className="fa fa-angle-left"></i>
                                                            </button>
                                                        </span>
                                                        <input type="text" name="quantity" value={this.state.quantity} onChange={this.changeQty} className="form-control input-number" />
                                                        <span className="input-group-prepend">
                                                            <button type="button" className="btn quantity-right-plus" onClick={this.plusQty} data-type="plus" data-field="">
                                                                <i className="fa fa-angle-right"></i>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="product-buttons">
                                                <button className="btn btn-solid" onClick={() => onAddToCartClicked(product, this.state.quantity)} >add to cart</button>
                                                {/* <Link to={`${process.env.PUBLIC_URL}/left-sidebar/PD/${product.SKU_PRODUCT_CD}`} className="btn btn-solid">view detail</Link> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        } 
        {/* End Beaty Theme */}
            </React.Fragment>
        )
    }
}

export default ProductItem;